type ErrorMessageProps = {
	inputId: string;
	errorMessage: string;
};

export default function ErrorMessage({ inputId, errorMessage }: ErrorMessageProps) {
	return (
		<p className="absolute mt-[1px] text-xs text-destructive" id={`${inputId}-error`}>
			{errorMessage}
		</p>
	);
}
